import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=b9e32c98"
import script from "./NotificationDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&id=b9e32c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports